import '../batman/document-verification-popup/document-verification-popup.js'
(function () {
  new Batman('dvsPopup', 'documentVerificationPopup');
})();
